
const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]'),
    data_zoom_in:document.querySelector("[data-zoom-in]"),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),
  };
  if(selectors.productMedia != null){
  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  }
  let zoom_data;
  class TemplateProductJS {
    constructor() {
      // Custom code for product page goes here
        let data_zoom_in = document.querySelector("[data-zoom-in]");
        let data_zoom_out = document.querySelector('[data-zoom-out]');
        if(data_zoom_in != null){
        data_zoom_in.addEventListener('click', (event)=>{
        let liveTarget = event.currentTarget;
        liveTarget.closest('[data-productwrapper]').classList.add('zomming')
        data_zoom_out.classList.remove('d-none');
        data_zoom_in.classList.add('d-none');
        zoom_data = event.currentTarget;
        this.productZoom(event.currentTarget);
      });
    }

    if(data_zoom_out != null){
        data_zoom_out.addEventListener('click', (event)=>{
        let liveTarget = event.currentTarget;
        data_zoom_out.classList.add('d-none');
        data_zoom_in.classList.remove('d-none');
        liveTarget.closest('[data-productwrapper]').classList.remove('zomming')
        zoom_data = event.currentTarget;
        this.productZoom(event.currentTarget);
      });
    }
    }

    productZoom(event) {


      if(event.classList.contains("zoom-in")){
          document.querySelectorAll('.image-zoom').forEach( ele => {
          ele.addEventListener('mousemove', this._triggerZoom.bind(this))
      })
    }
    if(event.classList.contains("zoom-out")){
      document.querySelectorAll('.image-zoom').forEach( ele => {
      ele.removeEventListener('mouseover', this._triggerZoom.bind(this))
    })
    }
  }

    _triggerZoom(e){

      if(zoom_data.classList.contains("zoom-in")){
      let x,y;
      var zoomer = e.currentTarget.closest('.zoom');
      if(zoomer !=null ){
      var offsetX = e.offsetX;
      var offsetY = e.offsetY;
      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
      e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
      x = offsetX/zoomer.offsetWidth*100
      y = offsetY/zoomer.offsetHeight*100
      zoomer.style.backgroundPosition = x + '% ' + y + '%';
      }
      else{
        return false;
      }
    }
  }

}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
